import {list} from "custom/demo/requests/admin/validation-reports";
import AdminList from "custom/demo/helpers/admin/list";

const actions = {list, new: true};

const columns = [
  {key: "email", label: "Email"},
  {key: "file_url", label: "File"},
  {key: "name", label: "Name", render: (record) => `${record.name}${record.automated ? " (Automated)" : ""}`},
  {key: "retest", label: "Retest", render: (record) => (record.retest ? "Yes" : "No")},
  {key: "study_name", label: "Study"}
];

export default function List() {
  return <AdminList actions={actions} columns={columns} name="Report" path="/admin/validation/reports" />;
}
